export default __webpack_public_path__ + "static/media/warning-triangle.d1f94296.svg";